import React                from 'react';
import {
    useLocation,
    Location
}                               from 'react-router-dom';

import InventoryItem            from 'shared/types/InventoryItem';

import MenuItem                 from 'components/MenuItem';
import * as InfiniteTableType   from 'components/InfiniteTable';
import dviDefectCheckboxes      from 'utils/dviDefectCheckboxes';

interface Props extends InfiniteTableType.Props {
    location? : Location;
}

class InventoryTable extends InfiniteTableType.InfiniteTable<InventoryItem,Props> {
    private dviDefects  = Object.assign({},...dviDefectCheckboxes);
    fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise('/api/maintenance/inventory','GET',undefined,{orderby,limit,skip});
    }
    renderThead() {
        return (
            <tr>
                <th onClick={()=>this.sort('partNumber')}>{this.getSortingIcon('partNumber')}Part Number</th>
                <th onClick={()=>this.sort('description')}>{this.getSortingIcon('description')}Description</th>
                <th onClick={()=>this.sort('compatibility')}>{this.getSortingIcon('compatibility')}Compatibility (Year/Make/Model)</th>
                <th onClick={()=>this.sort('supplier')}>{this.getSortingIcon('supplier')}Supplier</th>
                <th onClick={()=>this.sort('quantity')}>{this.getSortingIcon('quantity')}Quantity</th>
                <th onClick={()=>this.sort('pricePaid')}>{this.getSortingIcon('pricePaid')}PricePaid</th>
                <th onClick={()=>this.sort('taxPaid')}>{this.getSortingIcon('taxPaid')}Tax Paid</th>
            </tr>
        );
    }
    renderRow( inventoryItem: InventoryItem ) {
        const backgroundColor = this.props.location?.state?.selectedPartId === inventoryItem._id ? 'lightyellow' : 'white';
        return (
            <tr key={inventoryItem._id} style={{ backgroundColor }}>
                <td style={{ verticalAlign: 'top' }}>
                    {inventoryItem.partNumber}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {inventoryItem.description}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {Array.isArray(inventoryItem.compatibility) ? inventoryItem.compatibility.join(', ') : inventoryItem.compatibility}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {inventoryItem.supplier}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {inventoryItem.quantity}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    ${Number(inventoryItem.pricePaid).toFixed(2)}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    ${Number(inventoryItem.taxPaid).toFixed(2)}
                </td>
            </tr>
        );
    }

}

export const Inventory : React.FC<{}> = props =>{
    const location = useLocation();
    return (
        <MenuItem title="Inventory">
            <InventoryTable
                location={location}
            />
        </MenuItem>
    );
}

export default Inventory;